import React from 'react';
import { Quote } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const AboutPreview = () => {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-[#2A2A2A] text-[#D9D9D9]">
      <div className="container-custom">
        <motion.div
          className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div>
            <h2 className="section-title text-[#F5F5F5]">{t('home.about.title')}</h2>
            <p className="mb-6">{t('home.about.paragraph1')}</p>
            <p className="mb-8">{t('home.about.paragraph2')}</p>
          </div>
          <motion.div
            className="relative"
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.4, duration: 0.8 }}
          >
            <img
              src="images/2.6.webp"
              alt={t('home.about.imageAlt')}
              className="w-full h-[400px] object-cover"
            />
            <div className="absolute -bottom-4 -left-4 bg-[#C8102E] w-8 h-8" />
          </motion.div>
        </motion.div>

        <motion.div
          className="relative py-12 px-6 md:px-12 my-16 bg-[#1f1f1f] rounded-sm"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <Quote size={48} className="absolute -top-6 left-6 text-[#C8102E] opacity-50" />
          <blockquote className="text-xl md:text-2xl font-poppins font-light text-center max-w-4xl mx-auto">
            "{t('home.quote.text')}"
          </blockquote>
          <p className="text-center mt-6 text-sm text-[#AAAAAA]">- {t('home.quote.author')}</p>
        </motion.div>

        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <div className="hover:text-[#C8102E] transition-colors">
            <h3 className="text-lg md:text-xl font-poppins mb-3">{t('home.columns.philosophy.title')}</h3>
            <p className="text-sm text-[#D9D9D9]">{t('home.columns.philosophy.body')}</p>
          </div>
          <div className="hover:text-[#C8102E] transition-colors">
            <h3 className="text-lg md:text-xl font-poppins mb-3">{t('home.columns.approach.title')}</h3>
            <p className="text-sm text-[#D9D9D9]">{t('home.columns.approach.body')}</p>
          </div>
          <div className="hover:text-[#C8102E] transition-colors">
            <h3 className="text-lg md:text-xl font-poppins mb-3">{t('home.columns.expertise.title')}</h3>
            <p className="text-sm text-[#D9D9D9]">{t('home.columns.expertise.body')}</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutPreview;
